import { render, staticRenderFns } from "./TrainingAssessmentDialog.vue?vue&type=template&id=5191a1c4"
import script from "./TrainingAssessmentDialog.vue?vue&type=script&lang=ts"
export * from "./TrainingAssessmentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports